import { Button, ModalBody, ModalContent, ModalFooter } from '@nextui-org/react'
import { FC } from 'react'
import useHomeAssignGroupStore from '../../store/home/useHomeAssignGroupStore'
import { BaseDivider, BaseModal, BaseModalHeader } from '../common/Modal'
import { SelectUngroupedTanksCard } from './SelectUngroupedTanksCard'

export interface SelectUngroupedTanksProps {
  isOpen: boolean
  onOpen: () => void
  onOpenChange: () => void
}

export const SelectUngroupedTanks: FC<SelectUngroupedTanksProps> = ({
  isOpen,
  onOpenChange,
  onOpen,
}) => {
  const { selectedTanks, setBorderColor } = useHomeAssignGroupStore()

  const checkTanksBeforeContinue = (onClose1: () => void, onOpenNext: () => void) => {
    setBorderColor()
    if (selectedTanks.length !== 0) {
      onOpenNext()
      setTimeout(() => {
        onClose1()
      }, 50)
    }
  }

  return (
    <BaseModal isOpen={isOpen} onOpenChange={onOpenChange} size={'3xl'} isDismissable={true}>
      <ModalContent className="overflow-x-hidden">
        {(onClose) => (
          <>
            <BaseModalHeader
              title="Assign to Group"
              description="Select ungrouped tanks to assign to a batch group"
            />
            <ModalBody className="gap-1 min-h-[8rem] pl-6 sm:pl-10 pr-6 sm:pr-10 overflow-x-hidden overflow-y-auto">
              <BaseDivider />
              <SelectUngroupedTanksCard />
            </ModalBody>
            <ModalFooter className="pb-6 sm:pb-8 pl-6 sm:pl-10 pr-6 sm:pr-10">
              <div className="flex gap-3 justify-end w-full">
                <Button
                  variant="light"
                  className="font-bold text-tdplindigo border border-tdplindigo"
                  onPress={onClose}
                >
                  Cancel
                </Button>
                <Button
                  className="font-bold text-white w-[6rem] mr-0 bg-tdplplum"
                  onPress={() => {
                    checkTanksBeforeContinue(onClose, onOpen)
                  }}
                >
                  Continue
                </Button>
              </div>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </BaseModal>
  )
}
